requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    class FixedFooter extends HTMLElement {
      constructor() {
        super();

        this.mainContent = document.getElementById('MainContent');
        this.spacer = document.querySelector('.fixed-footer-spacer');
        this.overlay = document.querySelector('#footerOverlay');
        this.opacityOffset = 130;
        this.windowHeightLimitRatio = 1;

        this.onResize();
        window.addEventListener('MutationObserverLoaded', this.onResize.bind(this));
        window.addEventListener('throttle30fpsResize', this.onResize.bind(this));
        window.addEventListener('throttle60fpsScroll', this.onScroll.bind(this));
        window.addEventListener('updateFixedFooter', this.updateMainSizes.bind(this));
      }

      onResize() {
        if (window.isFullWidthLogoVisible) return;

        this.updateMainSizes();
        this.updateFooterSizes();
        this.checkStatus();
        this.checkMainOffset();
        this.checkVisibility();
      }

      onScroll() {
        if (window.isFullWidthLogoVisible) return;

        this.checkVisibility();
      }

      updateFooterSizes() {
        this.height = themeBounds.get(this).height;
      }

      updateMainSizes() {
        this.mainBounds = themeBounds.get(this.mainContent);
      }

      checkVisibility() {
        this.isVisible = themeBounds.get(this.mainContent).bottom - 200 <= themeBounds.get(this).bottom;
        this.classList[this.isVisible ? 'add' : 'remove']('fixed-footer--visible');
        this.checkOverlay();
      }

      checkStatus() {
        const mustBeFixed = themeBase.isDesktop && this.height < window.innerHeight * this.windowHeightLimitRatio && this.mainBounds.height > this.height + window.innerHeight;

        this.classList[mustBeFixed ? 'add' : 'remove']('fixed-footer--fixed');
        document.body.classList[mustBeFixed ? 'add' : 'remove']('fixed-footer-fixed');
        this.mustBeFixed = mustBeFixed;
      }

      checkMainOffset() {
        this.spacer.style.height = this.mustBeFixed ? `${this.height / 10}rem` : '';
      }

      checkOverlay() {
        if (!this.overlay) return;

        const mainBounds = themeBounds.get(this.mainContent);

        if (mainBounds.bottom - themeBase.windowHeight > 0) return;

        const difference = themeBounds.get(this).top - mainBounds.bottom + this.opacityOffset;
        const opacity = Math.max(Math.min(difference / this.height * -1, 1), 0);

        if (this.opacity === opacity) return;

        this.overlay.style.opacity = opacity;
        this.opacity = opacity;
      }
    }

    customElements.define('fixed-footer', FixedFooter);
  });
});